<template>
  <div class="projects" :class="{ project__invisible: !isActive }">
    <transition-group tag="div" name="list">
      <div
        class="project-item"
        v-for="(project, index) in projectList"
        :key="project.uuid"
      >
        <div class="showButton text-right project-item-button">
          <div class="button">
            <el-button
              :disabled="!(index > 0 && projectList.length > 1)"
              icon="el-icon-arrow-up"
              circle
              @click.stop="emit('move-up', index)"
            ></el-button>
          </div>
          <div class="button">
            <el-button
              :disabled="
                !(index + 1 != projectList.length && projectList.length > 1)
              "
              icon="el-icon-arrow-down"
              circle
              @click.stop="emit('move-down', index)"
            ></el-button>
          </div>
        </div>
        <div class="project-item-content">
          <slot :project="project" :index="index" />
          <div class="enter">
            <el-button
              icon="el-icon-delete"
              type="text"
              size="small"
              @click.stop="emit('delete-item', index)"
              >{{ deleteItemLabel }}</el-button
            >
          </div>
        </div>
      </div>
    </transition-group>
    <div class="add-project-item enter">
      <el-button icon="el-icon-plus" @click.stop="emit('add-project')">{{
        addLabel
      }}</el-button>
    </div>
    <div class="add-project-item enter">
      <el-button icon="el-icon-delete" @click.stop="emit('delete-job')">{{
        deleteJobLabel
      }}</el-button>
      <el-button icon="el-icon-check" @click.stop="emit('ok')">OK</el-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { ShokurekishoProjectItem } from '@/composables/format-edit/useShokurekishoFormatData'

const props = withDefaults(
  defineProps<{
    projects?: ShokurekishoProjectItem[]
    isActive: boolean
    addLabel: string
    deleteItemLabel: string
    deleteJobLabel?: string
  }>(),
  {
    projects: () => [],
    deleteJobLabel: '削除'
  }
)

const emit = defineEmits<{
  (e: 'add-project'): void
  (e: 'delete-job'): void
  (e: 'ok'): void
  (e: 'move-up', index: number): void
  (e: 'move-down', index: number): void
  (e: 'delete-item', index: number): void
}>()

const projectList = computed(() => props.projects || [])
</script>

<style lang="scss" scoped>
@use 'sass:color';

$basecolor: #f8f8f8;
$light-gray: #dcdfe6;
$errorcolor: #f56c6c;
$white: #fff;

.project__invisible {
  display: none;
}

.projects {
  margin-top: 0.5rem;
}

.project-item {
  display: flex;
  flex-direction: row-reverse;
  border-top: dashed 1px $light-gray;
  padding: 1rem 0;

  .enter {
    margin-top: 0.5rem;
  }
}

.project-item-button {
  display: flex;
  flex-direction: column;
  width: 3.5rem;

  .button {
    flex: 1;

    button {
      height: 100%;
      border-radius: 0;
      border: none;

      &.is-disabled {
        color: color.adjust($basecolor, $lightness: -5%);
      }
    }
  }
}

.project-item-content {
  flex: 1;
  margin: 0.5rem 0;
  padding: 0.5rem 1rem;

  .attention-limit {
    font-size: 0.75rem;
    color: $errorcolor;

    &.character {
      padding: 0.5rem 0;
    }

    &.column {
      background: $white;
      margin: 0.5rem 0;
      padding: 0.5rem 1rem;
    }
  }
}

.add-project-item {
  border-top: dashed 1px $light-gray;
  padding: 1rem;
  text-align: right;
}

.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}
</style>
